import React, { Component } from 'react';
export default class Quote extends Component {
  render() {
    return (
      <React.Fragment>
        <section id="quote">
            <h1>Shoot for the stars and you'll land on the moon</h1>
        </section>
      </React.Fragment>
    );
  }
}
